import {
  GalleryImageApiRequest,
  DeleteGalleryImageRequest,
} from '@/data/payload/api/GalleryImageRequest'
import {
  DeleteGalleryImageInterface,
  PostGalleryImageInterface,
} from '@/data/payload/contracts/GalleryImageRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { GalleryImageDataMapper } from '@/data/persistences/mappers/GalleryImageDataMapper'
import { GalleryImageRepositoryInterface } from '@/data/persistences/repositories/contracts/GalleryImageRepositoryInterface'
import { Image } from '@/domain/entities/GalleryImage'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class GalleryImageApiRepository
  implements GalleryImageRepositoryInterface {
  private service: ApiService
  private mapper: GalleryImageDataMapper

  constructor(service: ApiService, mapper: GalleryImageDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<Image> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.GALLERY,
      params
    )
    return this.mapper.convertGalleryImageFromApi(resp)
  }

  public async post(payload: PostGalleryImageInterface): Promise<Image> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.GALLERY,
      undefined,
      payload as GalleryImageApiRequest,
      undefined,
      'form-data'
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async delete(payload: DeleteGalleryImageInterface): Promise<Image> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.GALLERY_DELETE,
      undefined,
      payload as DeleteGalleryImageRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }
}
